export const formatDate = (
    dateString: string | undefined,
    formatType: "default" | "expiry" | "dateTime" | "shortDate" | "timeOnly" = "default"
  ): string => {
    if (!dateString) return "N/A";
  
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";
  
    let options: Intl.DateTimeFormatOptions;
  
    switch (formatType) {
      case "expiry":
        options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        };
        break;
  
      case "dateTime":
        options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        };
        break;
  
      case "shortDate":
        options = {
          day: "2-digit",
          month: "short",
          year: "numeric"
        };
        break;
  
      case "timeOnly":
        options = {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        };
        break;
  
      default:
        options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        };
    }
  
    return date.toLocaleString("en-US", options).replace(",", "");
  };
  